<template>
  <el-main>
    <el-button style="width: 100%" type="primary" @click="handleAddVehicle" > Add a new vehicle </el-button>
    <div v-if="vehicles.length > 0" style="margin-top: 10px">
      <div v-for="(vehicle, index) in vehicles" :key="index" class="vehicle__panel">
        <div class="card">
          <div class="list__item">
            <div>{{vehicle.model_year}}</div>
            <div>{{vehicle.plate_number}}</div>
            <div>{{vehicle.capacity}}</div>
            <div class="list__items__actions">
              <el-button
                @click.native.prevent="gotoEditVehicle(vehicle)"
                type="text"
                size="small">
                Edit
              </el-button>

              <el-button
                @click.native.prevent="deactivateVehicle(vehicle)"
                type="text"
                size="small">
                Deactivate
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      No vehicle has been created
    </div>
  </el-main>
</template>

<script>
import { getVehicles } from '@/services/vehicle'

export default {
  name: 'Vehicles',
  data () {
    return {
      vehicles: []
    }
  },
  mounted () {
    this.loadVehicles()
  },
  methods: {
    loadVehicles () {
      // call api to load all vehicles
      getVehicles()
        .then(res => {
          this.vehicles = res.data
        })
    },

    gotoEditVehicle (item) {
      this.$router.push({
        name: 'VehicleEdit',
        params: { id: item.id }
      })
    },

    deactivateVehicle () {},

    handleAddVehicle () {
      this.$router.push({
        name: 'VehicleAddEdit'
      })
    },

    gotoVehiclePage () {
      this.$router.push({
        name: 'Vehicle'
      })
    }
  }
}
</script>

<style lang="scss" src="./vehicles.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/vehicle/Vehicles.vue